import React from "react";
import { Flex, Link, Text } from "@chakra-ui/react";
import { Stat } from "../ViewProjectDetails";
import { formatTimeAgo } from "../../common/utils/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StatList = _ref => {
  let {
    stats
  } = _ref;
  if (stats === null) return;
  return stats.oso_codeMetricsByProjectV1[0].contributorCount > 0 ? /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx("h4", {
      className: "text-3xl mt-5 ml-4",
      children: "Impact stats"
    }), /*#__PURE__*/_jsxs(Flex, {
      gap: 2,
      flexDir: {
        base: "column",
        md: "row"
      },
      py: 6,
      px: 3,
      children: [/*#__PURE__*/_jsx("div", {
        className: "rounded-2xl bg-gray-50 flex-auto p-3 md:p-6 gap-4 flex flex-col",
        children: /*#__PURE__*/_jsxs("div", {
          children: [" ", /*#__PURE__*/_jsx(Stat, {
            isLoading: false,
            value: `${formatTimeAgo(stats.oso_codeMetricsByProjectV1[0].firstCommitDate)}`,
            children: "Project age"
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "rounded-2xl bg-gray-50 flex-auto p-3 md:p-6 gap-4 flex flex-col",
        children: /*#__PURE__*/_jsx(Stat, {
          isLoading: false,
          value: `${stats.oso_codeMetricsByProjectV1[0].contributorCount}`,
          children: "Unique code contributors"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "rounded-2xl bg-gray-50 flex-auto p-3 md:p-6 gap-4 flex flex-col",
        children: /*#__PURE__*/_jsx(Stat, {
          isLoading: false,
          value: `${projectDevs(stats)}`,
          children: "Active devs"
        })
      })]
    }), /*#__PURE__*/_jsxs(Text, {
      fontFamily: "DM Mono",
      textAlign: "center",
      mt: 0,
      className: "text-xs",
      children: ["Data provided by", " ", /*#__PURE__*/_jsx(Link, {
        href: "https://www.opensource.observer/",
        target: "_blank",
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          className: "text-gitcoin-violet-500",
          children: "opensource.observer"
        })
      })]
    })]
  }) : /*#__PURE__*/_jsx("div", {});
};
function projectDevs(stats) {
  return stats.oso_codeMetricsByProjectV1[0].activeDeveloperCount6Months;
}